module.exports = __webpack_public_path__ + "img/xggq1.676f1db4.jpg";